import TextOverBackgroundImage from './TextOverBackgroundImage';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { withModel } from '../../data-providers/model';
import withOnTrackLink from '../../hocs/withOnTrackLink';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withModel,
  mapProps(props => ({
    ...props.primary,
    link: localiseUrl(props.model.countryModel, props.primary.link),
  })),
  withOnTrackLink,
);

export default enhance(TextOverBackgroundImage);



// WEBPACK FOOTER //
// ./src/client/js/view/components/TextOverBackgroundImage/index.js